import logoImage from "public/images/knicks/knicks-mock-logo.png";
import { routes } from "src/shared/routes";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import {
  FAQS,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";

export const pass_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "pass_sandbox",
  TEAM_FULL_NAME: "Sacramento Kings",
  BROWSER_TITLE: "Sacramento Kings",
  CLIENT_ID: "6b6c129ee955.seasonshare.sackings-sackings.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#c4ced4",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  },
};
